import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'LbsReal'
}

import NormalInput from '../NormalInput.vue'
import PopupPickerSingleCol from '../picker/PopupPickerSingleCol.vue'
// import PopupLbsList from '../picker/PopupLbsList.vue'
import AuthConfirm from '../agreements/LocationAuthConfirm.vue'
import AgreementLocation from '../agreements/AgreementLocation.vue'
import { replaceUrl, isAutoSaveFormEnabled } from '@/utils/index'
import { getCityIdAndNearest, getShopNearestList, getPickerOptions, getLocation } from './util'
import {
  MINI_lbs_city_code_not_found,
  MINI_lbs_city_code_not_match,
  MINI_lbs_get_location_fail,
  MINI_lbs_get_location_success,
  MINI_lbs_model_no,
  MINI_lbs_model_show,
  MINI_lbs_model_yes
} from '@/canvas/constants/reportEvents'
import Vue, { computed, ref, watch, Ref, nextTick } from 'vue'
import { LBSTYPE, ILBS } from './constant'
import type { Column, PickerInfo } from './constant'
import {
  isFormAutoModalLocation,
  isFormAutoLocation,
  isFormAutoLocationOrAuth
} from '@/canvas/utils'
import { useStore } from 'vue2-helpers/vuex'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Object,
    default: () => ({})
  },
  themeColor: {
    type: String,
    default: '#0a8afa'
  },
  history: {
    type: Object,
    default: () => ({})
  },
  isFloat: {
    type: Boolean,
    default: false
  },
  formId: {
    type: [String, Number],
    default: 0
  }
},
  emits: ['focus', 'change'],
  setup(__props, { emit: emits }) {

const props = __props;

const $reportUI = Vue.prototype.$reportUI
const store = useStore()
const privacyRef = ref<HTMLFormElement | null>(null)
const authRef = ref<null | HTMLFormElement>(null)



const isLocationSet = ref({
  checked: false, // 是否允许自动获取地理位置
  confirmShow: false, // 是否展示过授权确认弹窗
  nearRole: false, // 是否开启临近门店功能
  once: false, // 是否已经获取过位置信息了
  useNearList: false // 是否使用最近列表
})
const myLocation = ref({
  success: false, // 是否成功获取到经纬度
  lng: '', // 经度
  lat: '' // 维度
})
const pickerInfos = ref<PickerInfo[]>([]) // 不同列表信息

const doShowPicker = ref(() => {}) // 维护一个正常展示picker面板的行为

const optionsObj: Ref<ILBS> = computed(() => {
  try {
    return JSON.parse(props.data.options)
  } catch (e) {
    return {}
  }
})
const initChildren = computed(() => {
  return optionsObj.value.children
})
const fields: Ref<{ type: string; name: string }[]> = computed(() => {
  return optionsObj.value.fields || []
}) // 组合的fields
const hasItem = computed(() => {
  return {
    shop: fields.value.map((f) => f.type).includes(LBSTYPE.SHOP), // 是否含有门店选项
    product: fields.value.map((f) => f.type).includes(LBSTYPE.PRODUCT) // 是否含有产品选项
  }
})
const locationAuthModal = computed(() => {
  return store.state.locationAuthModal
})
const storeHistory = computed(() => {
  return store.state.history
})

const checkboxValue = computed({
  get: () => {
    return isFormAutoLocationOrAuth()
      ? !!storeHistory.value.is_lbs_authorized
      : isLocationSet.value.checked
  },
  set: (val: boolean) => {
    if (isFormAutoLocationOrAuth()) {
      if (val !== storeHistory.value.is_lbs_authorized) {
        setHistoryByPhone({
          ...storeHistory.value,
          is_lbs_authorized: val ? 1 : 0
        })
      }
    } else {
      isLocationSet.value.checked = val
    }
  }
})
const isLocationNearSuccess = computed(() => {
  return checkboxValue.value && myLocation.value.success && isLocationSet.value.nearRole
}) // 是否允许使用lbs，且已经存在合法的位置信息

const setLocationAuthModal = (payload: any) => {
  store.commit('setLocationAuthModal', payload)
}
const setHistoryByPhone = (payload: any) => {
  store.commit('setHistoryByPhone', payload)
}
watch(
  () => checkboxValue.value,
  (val) => {
    replaceUrl({ allow_lbs: Number(!!val) })
  }
)
watch(
  () => props.history,
  (newValue, oldValue) => {
    if (oldValue.isEmpty) {
      // isLocationSet.value.once = !!newValue.is_lbs_authorized
      checkboxValue.value = !!newValue.is_lbs_authorized
    }
  }
)
const showAuthModal = () => {
  if (!isFormAutoLocationOrAuth()) {
    return
  }
  // 是否自动设置过位置信息
  if (!isLocationSet.value.once) {
    // 自动获取位置信息按钮是否被选中
    if (checkboxValue.value) {
      if (isFormAutoLocation() || locationAuthModal.value.agree) {
        pickLocation()
      }
      if (!locationAuthModal.value.hasShow) {
        setLocationAuthModal({
          ...locationAuthModal.value,
          hasShow: true
        })
      }
      return
    }
    // 当前组件是否展示过位置授权弹窗
    if (!isLocationSet.value.confirmShow && isFormAutoModalLocation()) {
      // 全局的授权弹窗是否已经展示过
      if (locationAuthModal.value?.hasShow) {
        if (props.isFloat && checkboxValue.value) {
          onLocationConfirm()
        }
        return
      }
      // 当前组件是否展示过位置授权弹窗，没有展示过，则展示一下
      if (authRef.value && authRef.value) {
        authRef.value?.open()
        setLocationAuthModal({
          ...locationAuthModal.value,
          hasShow: true
        })
      }
      return
    }
  }
}

watch(
  () => storeHistory.value,
  (val, oldVal) => {
    showAuthModal()
  }
)

watch(
  () => props.data,
  (newValue, oldValue) => {
    if (!isAutoSaveFormEnabled()) {
      return
    }
    if (newValue) {
      if (!newValue.levels && newValue.levels !== oldValue.levels) {
        props.data.levels = oldValue.levels
      }
      if (!newValue.value && newValue.value !== oldValue.value) {
        props.data.value = oldValue.value
      }
    }
  }
)
function setItemRef(el: HTMLFormElement, picker: PickerInfo) {
  if (el) {
    picker.ref = el
  }
}
const initPickerInfo = () => {
  let level = 0

  const defaultSelected = optionsObj.value.default || []

  for (const f of fields.value) {
    pickerInfos.value.push({
      level,
      ref: null,
      field: f,
      selected: {
        id: defaultSelected[level] || 0,
        idx: undefined,
        name: ''
      },
      columns: []
    } as PickerInfo)
    level++
  }
  // 第一个选项默认有选项
  pickerInfos.value[0].columns = getPickerOptions(initChildren.value!)
  if (hasItem.value.product) {
    // 有产品选项时，自动填充第一个
    onConfirm({ idx: 0 }, pickerInfos.value[0])
  }
  console.log('pickerInfos.value', pickerInfos.value)
}
const setSelect = (picker: PickerInfo, id?: number, idx?: number) => {
  let column: Column = {
    id: 0,
    idx: undefined,
    name: ''
  }
  if (id) {
    column =
      picker.columns.filter((c) => {
        return c.id === id
      })[0] || {}
  } else if (idx! >= 0) {
    column = picker.columns[idx!]
  }

  Object.assign(picker.selected, column)
}

const onChange = () => {
  const data = props.data
  const infos = pickerInfos.value.map((item) => {
    return item.selected
  })
  data.value = infos
    .map((i) => i?.name)
    .filter((i) => !!i)
    .join(',')
  data.code = infos
    .map((i) => i?.id)
    .filter((i) => !!i)
    .join(',')
  // 当选择完成时触发验证
  if (data.levels === infos.filter((i) => i.idx! >= 0).length) {
    emits('change')
  }
}
const showPicker = (picker: PickerInfo) => {
  try {
    picker.ref && picker.ref.open()
  } catch (e) {
    console.log(e)
  }
}
const onClick = (picker: PickerInfo) => {
  doShowPicker.value = () => {
    showPicker(picker)
    doShowPicker.value = () => {}
  }
  // 未自动填充过, 且点击的选项不是商品时，获取位置信息并进行LBS
  if (picker.field.type !== LBSTYPE.PRODUCT && !isLocationSet.value.once) {
    if (checkboxValue.value) {
      // 已经授权, 获取信息
      pickLocation()
      return
    }
    if (!isLocationSet.value.confirmShow) {
      if (isFormAutoLocationOrAuth()) {
        if (!locationAuthModal.value?.hasShow) {
          authRef.value?.open()
          return
        }
      } else {
        // 没展示过位置授权，展示一下
        authRef.value?.open()
        return
      }
    }
  }
  showPicker(picker)
}

const onConfirm = async ({ idx }: { idx: number }, picker: PickerInfo) => {
  // 点击确认按钮时触发
  if (idx === -1) {
    // idx为-1说明是自动选择的，地位后获取的id可能不在选项中
    $reportUI(MINI_lbs_city_code_not_match)
    nextTick(() => {
      showPicker(picker)
    })
    return
  }
  if (picker.selected.idx === idx) {
    // 选项没有改变
    return
  }
  setSelect(picker, undefined, idx)
  clearNext(picker.level + 1)
  // if (picker.field.type === LBSTYPE.CITY && isLocationNearSuccess.value && hasItem.value.shop) {
  //   // 选择了城市，且存在店铺，且已经允许定位，则请求距离最近的商铺
  //   setShopList(
  //     picker.selected.id + '',
  //     (shopList) => {
  //       const shopPicker = pickerInfos.value.filter((p) => p.field.type === LBSTYPE.SHOP)[0] || {}
  //       shopPicker.columns = shopList
  //       console.log('shopPicker', shopPicker)
  //       isLocationSet.value.useNearList = true
  //     },
  //     () => {
  //       clearNext(picker.level + 1)
  //     }
  //   )
  //   onChange()
  //   return
  // }
  console.log('picker.field.type === LBSTYPE.CITY', picker.field.type === LBSTYPE.CITY)
  console.log(picker.field.type)
  console.log('hasItem.value.shop', hasItem.value.shop)
  if (picker.field.type === LBSTYPE.CITY && hasItem.value.shop) {
    // 取随机项填充
    for (const picker of pickerInfos.value) {
      if (picker.field.type === LBSTYPE.SHOP && picker.columns.length > 0) {
        const idx = Math.floor(Math.random() * picker.columns.length)
        onConfirm({ idx }, picker)
      }
    }
    onChange()
    return
  }
  if (picker.field.type === LBSTYPE.PRODUCT && isLocationNearSuccess.value) {
    // 如果选择了产品，并且已经允许了lbs，自动填充下面最近的信息
    try {
      doLBS()
    } catch {
      clearNext(picker.level + 1)
    }
    onChange()
    return
  }
  if (picker.field.type !== LBSTYPE.SHOP) {
    // 如果选择了其他选项，先把shop组件卸载
    isLocationSet.value.useNearList = false
  }
  onChange()
}
const clearNext = (level: number) => {
  if (level >= fields.value.length) {
    return
  }
  for (let lv = level; lv < fields.value.length; lv++) {
    setSelect(pickerInfos.value[lv])
    pickerInfos.value[lv].columns = []
  }
  const nextPicker = pickerInfos.value[level]
  const ids = pickerInfos.value.map((p) => p.selected.idx!).slice(0, level)
  nextPicker.columns = getPickerOptions(initChildren.value!, ids)
}
const setShopList = async (
  cityId: string,
  callback: (list: Column[]) => void,
  failback: () => void
) => {
  const location = { latitude: myLocation.value.lat, longtitude: myLocation.value.lng }
  const ids = { formId: props.formId, itemId: props.data.id }
  const product = (hasItem.value.product ? pickerInfos.value[0].selected.name : '').replace(
    '+',
    '%2B'
  )
  try {
    const shopList = await getShopNearestList(location, ids, cityId, product)
    if (shopList && shopList.length) {
      callback(shopList)
    }
  } catch {
    failback()
  }
}
const autoPick = async (fills: { provinceId: number; cityId: number; providerName?: string }) => {
  for (const picker of pickerInfos.value) {
    // 自动填充
    if (picker.field.type === LBSTYPE.PROVINCE) {
      const idx = picker.columns.findIndex((c) => Number(c.id) === Number(fills.provinceId))
      onConfirm({ idx }, picker)
      if (idx === -1) {
        break
      }
    }
    if (picker.field.type === LBSTYPE.CITY) {
      const idx = picker.columns.findIndex((c) => Number(c.id) === Number(fills.cityId))
      onConfirm({ idx }, picker)
      if (idx === -1) {
        break
      }
    }
    if (picker.field.type === LBSTYPE.SHOP) {
      setShopList(
        fills.cityId + '',
        (shopList) => {
          picker.columns = shopList
          const idx = picker.columns.findIndex((c) => c.name === fills.providerName)
          isLocationSet.value.useNearList = true
          onConfirm({ idx }, picker)
        },
        () => {
          onConfirm({ idx: -1 }, picker)
        }
      )
    }
  }
}
const doLBS = async () => {
  const location = { latitude: myLocation.value.lat, longtitude: myLocation.value.lng }
  const ids = { formId: props.formId, itemId: props.data.id }
  const product = (hasItem.value.product ? pickerInfos.value[0].selected.name : '').replace(
    '+',
    '%2B'
  )
  const {
    china_admin_code: cityId,
    province_code: provinceId,
    shop_name: providerName
  } = await getCityIdAndNearest(location, ids, product)
  if (cityId) {
    autoPick({
      provinceId,
      cityId,
      providerName
    })
  } else {
    $reportUI(MINI_lbs_city_code_not_found)
    doShowPicker.value()
  }
}
const pickLocation = () => {
  isLocationSet.value.once = true
  getLocation(
    (lng: string, lat: string) => {
      if (lat && lng) {
        myLocation.value = {
          success: true,
          lat,
          lng
        }
      }
      doLBS()
      $reportUI(MINI_lbs_get_location_success)
    },
    () => {
      doShowPicker.value()
      $reportUI(MINI_lbs_get_location_fail)
    }
  )
}

// LBS授权相关
const onLocationConfirm = () => {
  allowLBS()
  pickLocation()
  if (isFormAutoLocationOrAuth() && !locationAuthModal.value?.agree) {
    setLocationAuthModal({
      ...locationAuthModal.value,
      agree: true
    })
  }
  authRef.value && authRef.value.close()
  $reportUI(MINI_lbs_model_yes)
}
const onLocationRefuse = () => {
  $reportUI(MINI_lbs_model_no)
}
const onModalOpen = () => {
  isLocationSet.value.confirmShow = true
  $reportUI(MINI_lbs_model_show)
}
const allowLBS = () => {
  // 同意使用位置信息
  checkboxValue.value = true
}

// 初始化
const init = () => {
  initPickerInfo()
  isLocationSet.value.nearRole = !!(window as any as any)?._globalData?.isShowDistanceLbs || false
  props.data.levels = fields.value.length
}
init()

return { __sfc: true,$reportUI, store, privacyRef, authRef, props, emits, isLocationSet, myLocation, pickerInfos, doShowPicker, optionsObj, initChildren, fields, hasItem, locationAuthModal, storeHistory, checkboxValue, isLocationNearSuccess, setLocationAuthModal, setHistoryByPhone, showAuthModal, setItemRef, initPickerInfo, setSelect, onChange, showPicker, onClick, onConfirm, clearNext, setShopList, autoPick, doLBS, pickLocation, onLocationConfirm, onLocationRefuse, onModalOpen, allowLBS, init, NormalInput, PopupPickerSingleCol, AuthConfirm, AgreementLocation, LBSTYPE }
}

})